declare const BackgroundPositions: ["top", "bottom", "left", "right", "center", any];
export declare type BackgroundPosition = typeof BackgroundPositions[number];

declare const BackgroundSizes: ["contain", "cover", 'auto'];
export declare type BackgroundSize = typeof BackgroundSizes[number];

declare const BackgroundShadeColors: ["black", "lightblue"];
export declare type BackgroundShadeColor = typeof BackgroundShadeColors[number];

interface BackgroundProps {
  children: any;
  src: string;
  position: BackgroundPosition;
  parallax: boolean;
  repeat: boolean;
  size: BackgroundSize;
  style?: any;
  className?: string;
  shade?: boolean | BackgroundShadeColor;
}

const defaultProps: BackgroundProps = {
  children: <div></div>,
  src: "https://via.placeholder.com/1000x250/E6EAED/CCCCCC/",
  position: "center",
  parallax: true,
  shade: true,
  repeat: false,
  size: "cover",
};

const Background = ({ style, children, className, src, shade, parallax, position, repeat, size }: BackgroundProps) => {
  const css: any = ["covr-background"];
  const settings: any = {
    backgroundAttachment: parallax ? "fixed" : "scroll",
    backgroundImage: `url(${src})`,
    backgroundPosition: position,
    backgroundRepeat: repeat ? "repeat" : "no-repeat",
    backgroundSize: size,
    ...style,
  };

  if (shade === 'black') {
    css.push("shade black");
  }else if (shade === 'lightblue') {
    css.push("shade lightblue");
  }else {
    css.push("shade black");
  }

  css.push(className);

  return (
    <div className={css.join(" ")} style={settings}>
      {children}
    </div>
  );
};

Background.defaultProps = defaultProps;

export default Background;
